export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const SET_CURRENT_PROFILE = 'SET_CURRENT_PROFILE'
export const SET_PROFILE = 'SET_PROFILE'
export const SET_TOKEN = 'SET_TOKEN'
